import { IErrorNotifier } from "./types";

function createConsoleNotifier(): IErrorNotifier {
  return {
    notify: async (params) => {
      if (
        !(params instanceof Error) &&
        typeof params !== "string" &&
        params?.severity === "warn"
      ) {
        console.warn(stringifyNotifierParams(params));
      } else {
        console.error(stringifyNotifierParams(params));
      }
    },
  };
}

function stringifyNotifierParams(
  params: Parameters<IErrorNotifier["notify"]>[0]
): string {
  if (params instanceof Error) {
    return params.message;
  }

  if (typeof params === "string") {
    return params;
  }

  return `error: ${params.error ?? null}, message: ${params.msg ?? null} on ${
    params.context ?? null
  }`;
}

export { createConsoleNotifier };
